<template>
  <transition name="alert-fade">
    <div class="dialog-tips dialog-center" id="toast" v-show="visible">{{message}}</div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      message: ''
    }
  }
}
</script>
<style lang="less" scoped>
.alert-fade-enter-active,
.alert-fade-leave-active {
  transition: opacity 0.3s;
}
.alert-fade-enter,
.alert-fade-leave-to {
  opacity: 0;
}
.dialog-tips {
  position: fixed;
  z-index: 100;
  min-width: 220px;
  padding: 30px;
  border-radius: 5px;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: 0px 8px 30px 0 rgba(0, 0, 0, 0.4);
  text-align: center;
  color: #fff;
}
.dialog-center {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>